export const UIDS = {
  page: "api::page.page",
};

export const RelationTypesIds = {
  page: "relations.page-relation",
  link: "relations.link-relation",
};
